const sizeVariants = {
  sm: "12_16_500",
  md: "12_18_500",
  lg: "14_18_500"
};
export {
  sizeVariants
};
//# sourceMappingURL=constants.js.map
